import { NextApiResponse } from 'next';
import { ErrorResponse } from '../interface/api';

export const sendErrorResponse = ({
  res,
  status,
  type,
  message,
  shouldRedirect = false,
}: {
  res: NextApiResponse;
  status: number;
  type: string;
  message: string;
  shouldRedirect?: boolean;
}) => {
  const errorResponse: ErrorResponse = {
    errors: [{ type, message }],
    redirect: shouldRedirect,
  };
  return res.status(status).json(errorResponse);
};

export const sendSuccessResponse = ({
  res,
  status,
  data,
}: {
  res: NextApiResponse;
  status: number;
  data: any;
}) => {
  return res.status(status).json(data);
};
